const PASS_THROUGH_KEYS = ['pharmacy_visit_uid', 'followup_uid', 'password_recovered'] as const

type PassThroughParams = Partial<Record<(typeof PASS_THROUGH_KEYS)[number], string>>

export const extractPassThroughParams = (search: string): PassThroughParams => {
  const url = new URLSearchParams(search)
  const result: PassThroughParams = {}
  for (const key of PASS_THROUGH_KEYS) {
    const value = url.get(key)
    if (value) result[key] = value
  }
  return result
}

export const appendPassThroughToUrl = (
  targetUrl: string,
  passThrough: PassThroughParams,
): string => {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost'
  const url = new URL(targetUrl, origin)
  for (const [key, value] of Object.entries(passThrough)) {
    if (value !== undefined) {
      url.searchParams.set(key, value)
    }
  }
  return url.toString()
}
